module.exports = __webpack_public_path__ + "static/media/nightMode.6435d14e.svg";